import type { CollectionDefaults, StoreCore, StoreSchema } from '@rstore/shared';
import type { ResolvedMonospaceCollection } from '#layers/data-model/public';

/** Only the workspace store defines `MonospaceCollection`; the system store has no schema collection. */
type SchemaCollectionStore = StoreCore<StoreSchema, CollectionDefaults> & {
	MonospaceCollection?: { peekFirst: (options: { filter: { apiName: string } }) => ResolvedMonospaceCollection | null | undefined };
};

export function resolveSchemaCollection({ collectionName, store }: { collectionName: string; store: SchemaCollectionStore }) {
	return store.MonospaceCollection?.peekFirst({ filter: { apiName: collectionName } }) ?? undefined;
}
